import { MissingState, SET_FAULTY_SECTIONS, SET_UNFINISHED_MODULE } from './types';
import { Actions } from '..';

const initialState: MissingState = {
	unfinishedSections: [],
	missingCoverSections: [],
	standaloneSofabed: [],
	unfinishedModule: null,
};

export function missingReducer(state = initialState, action: Actions): MissingState {
	switch (action.type) {
		case SET_FAULTY_SECTIONS: {
			const { missingCoverSections, unfinishedSections, standaloneSofabed } = action;
			return { ...state, unfinishedSections, missingCoverSections, standaloneSofabed };
		}
		case SET_UNFINISHED_MODULE: {
			return { ...state, unfinishedModule: action.value };
		}
		default:
			return state;
	}
}
